module.exports = __webpack_public_path__ + "static/logo-218459f7922190c9ba1f13460ebaad49.png";